export default __webpack_public_path__ + "static/media/coming_soon.ed70f98f.jpg";